import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Find drawer elements by ID
    this.badgeDrawer = document.getElementById('badge-drawer')
    this.feedbackDrawer = document.getElementById('feedback-drawer')
    
    // Track badge drawer opening
    if (this.badgeDrawer) {
      this.badgeDrawer.addEventListener('change', this.handleBadgeDrawerChange.bind(this))
    }
    
    // Track feedback drawer opening  
    if (this.feedbackDrawer) {
      this.feedbackDrawer.addEventListener('change', this.handleFeedbackDrawerChange.bind(this))
    }

    this.preloadNotifications()
  }

  disconnect() {
    // Clean up event listeners
    if (this.badgeDrawer) {
      this.badgeDrawer.removeEventListener('change', this.handleBadgeDrawerChange.bind(this))
    }
    
    if (this.feedbackDrawer) {
      this.feedbackDrawer.removeEventListener('change', this.handleFeedbackDrawerChange.bind(this))
    }
  }

  handleBadgeDrawerChange(event) {
    if (event.target.checked) {
      this.markBadgesAsViewed()
    }
  }

  handleFeedbackDrawerChange(event) {
    if (event.target.checked) {
      this.markFeedbackAsViewed()
    }
  }

  async markBadgesAsViewed() {
    try {
      const formData = new FormData()
      formData.append('preference_key', 'last_badges_viewed_at')
      
      const response = await fetch('/users/update_preferences', {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': this.getCSRFToken()
        },
        body: formData
      })
      
      if (response.ok) {
        const data = await response.json()
        this.updateBadgeCount(data.count)
      }
    } catch (error) {
      console.error('Failed to mark badges as viewed:', error)
    }
  }

  async markFeedbackAsViewed() {
    try {
      const formData = new FormData()
      formData.append('preference_key', 'last_feedback_viewed_at')
      
      const response = await fetch('/users/update_preferences', {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': this.getCSRFToken()
        },
        body: formData
      })
      
      if (response.ok) {
        const data = await response.json()
        this.updateFeedbackCount(data.count)
      }
    } catch (error) {
      console.error('Failed to mark feedback as viewed:', error)
    }
  }

  updateBadgeCount(count) {
    const badgeButton = document.querySelector('label[for="badge-drawer"]')
    
    if (badgeButton) {
      const badgeCountElement = badgeButton.parentElement.querySelector('.absolute')
      
      if (badgeCountElement) {
        if (count === 0) {
          badgeCountElement.style.display = 'none'
        } else {
          badgeCountElement.textContent = count
          badgeCountElement.style.display = 'flex'
        }
      }
    }
  }

  updateFeedbackCount(count) {
    const feedbackButton = document.querySelector('label[for="feedback-drawer"]')
    
    if (feedbackButton) {
      const feedbackCountElement = feedbackButton.parentElement.querySelector('.absolute')
      
      if (feedbackCountElement) {
        if (count === 0) {
          feedbackCountElement.style.display = 'none'
        } else {
          feedbackCountElement.textContent = count
          feedbackCountElement.style.display = 'flex'
        }
      }
    }
  }

  getCSRFToken() {
    const token = document.querySelector('meta[name="csrf-token"]')
    return token ? token.getAttribute('content') : ''
  }

  preloadNotifications() {
    fetch('/notifications')
      .then(r => r.text())
      .then(html => {
        const containers = document.querySelectorAll('[data-controller="notifications"] [data-notifications-target="list"]')
        containers.forEach(container => { container.innerHTML = html })
      })
      .catch(() => {})
  }
} 